import "../css/sky-single-product.scss";


document.addEventListener('DOMContentLoaded', function () {
    const quantityContainers = document.querySelectorAll('body.single-product .product form.cart .quantity');

    quantityContainers.forEach(container => {
        const input = container.querySelector('input[type="number"]');
        if (!input) return;

        container.addEventListener('click', function (e) {
            const rect = container.getBoundingClientRect();
            const isLeftSide = e.clientX - rect.left < rect.width / 3;
            const isRightSide = e.clientX - rect.left > (2 * rect.width) / 3;

            if (isLeftSide || isRightSide) {
                e.preventDefault();
                updateQuantity(isLeftSide ? -1 : 1);
            }
        });

        function updateQuantity(change) {
            let newValue = parseInt(input.value, 10) + change;
            let minValue = parseInt(input.getAttribute('min'), 10) || 1;
            let maxValue = parseInt(input.getAttribute('max'), 10) || Infinity;

            newValue = Math.max(minValue, Math.min(maxValue, newValue));
            input.value = newValue;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        input.addEventListener('input', function () {
            let value = parseInt(this.value, 10);
            if (isNaN(value)) {
                this.value = this.defaultValue;
            } else {
                let minValue = parseInt(this.getAttribute('min'), 10) || 1;
                let maxValue = parseInt(this.getAttribute('max'), 10) || Infinity;
                this.value = Math.max(minValue, Math.min(maxValue, value));
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const config = { childList: true, subtree: true };
    const observer = new MutationObserver(function (mutations) {
        for (let mutation of mutations) {
            if (mutation.type === 'childList') {
                const slider = document.querySelector('.flex-control-nav.flex-control-thumbs');
                if (slider) {
                    observer.disconnect();
                    initializeSlider(slider);
                    break;
                }
            }
        }
    });

    observer.observe(document.body, config);
});

function initializeSlider(slider) {
    // Wrap the slider in a new container
    const wrapper = document.createElement('div');
    wrapper.className = 'flex-control-nav-wrapper';
    slider.parentNode.insertBefore(wrapper, slider);
    wrapper.appendChild(slider);

    // Add data attribute to slider
    slider.setAttribute('data-gallery-slider', '');

    // Create and inject navigation buttons
    const navContainer = createNavigation(slider);
    wrapper.appendChild(navContainer);

    // Initialize drag functionality
    initializeDrag(slider);

    // Add keyboard navigation
    addKeyboardNavigation(slider);

    // Call adjustLayout initially
    adjustLayout(slider);

    // Add resize listener
    window.addEventListener('resize', throttle(() => {
        adjustLayout(slider);
    }, 250));

    // Observe changes to flex-active class
    const flexActiveObserver = new MutationObserver(throttle(() => {
        adjustLayout(slider);
    }, 250));

    flexActiveObserver.observe(slider, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });

    // Add scroll event listener to update button visibility
    slider.addEventListener('scroll', throttle(() => {
        if (!isDragging) {
            updateButtonVisibility(slider);
        }
    }, 150));

    // Initial check for button visibility
    updateButtonVisibility(slider);
}

function createNavigation(slider) {
    const navContainer = document.createElement('div');
    navContainer.className = 'thumbnail-nav';
    ['prev', 'next'].forEach(direction => {
        const button = document.createElement('button');
        button.className = direction;
        button.textContent = direction === 'prev' ? '←' : '→';
        button.setAttribute('aria-label', `${direction} image`);
        button.addEventListener('click', () => {
            const scrollAmount = direction === 'prev' ? -slider.offsetWidth : slider.offsetWidth;
            smoothScroll(slider, scrollAmount, 300);
        });
        navContainer.appendChild(button);
    });
    return navContainer;
}

let isDragging = false;

function initializeDrag(slider) {
    let startX;
    let startScrollLeft;

    function getPositionX(e) {
        return e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    }

    function startDragging(e) {
        isDragging = true;
        startX = getPositionX(e);
        startScrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
        slider.style.userSelect = 'none';
    }

    function drag(e) {
        if (!isDragging) return;
        e.preventDefault();  // This line is now safe
        const currentX = getPositionX(e);
        const dx = startX - currentX;
        slider.scrollLeft = startScrollLeft + dx;
    }

    function stopDragging() {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = 'grab';
        slider.style.removeProperty('user-select');

        // Delay snapping to edge to ensure smooth transition
        setTimeout(() => {
            snapToEdge(slider);
        }, 100);
    }

    // Adding `passive: false` to touch event listeners
    slider.addEventListener('mousedown', startDragging);
    slider.addEventListener('touchstart', startDragging, { passive: false });

    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag, { passive: false });

    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchend', stopDragging);

    slider.addEventListener('click', function (e) {
        if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true);
}


function addKeyboardNavigation(slider) {
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            smoothScroll(slider, -slider.offsetWidth, 300);
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            smoothScroll(slider, slider.offsetWidth, 300);
        }
    });
}

function adjustLayout(slider) {
    const wrapper = slider.closest('.flex-control-nav-wrapper');
    const thumbnails = slider.querySelectorAll('li');
    const totalThumbnails = thumbnails.length;
    const sliderWidth = slider.offsetWidth;

    let visibleThumbnails, minThumbnailWidth, maxThumbnailWidth;

    // Responsive breakpoints
    if (window.innerWidth >= 1200) {
        visibleThumbnails = totalThumbnails;
        minThumbnailWidth = 80;
        maxThumbnailWidth = 120;
    } else if (window.innerWidth >= 992) {
        visibleThumbnails = 3;
        minThumbnailWidth = 70;
        maxThumbnailWidth = 100;
    } else if (window.innerWidth >= 768) {
        visibleThumbnails = 4;
        minThumbnailWidth = 60;
        maxThumbnailWidth = 80;
    } else {
        visibleThumbnails = Math.floor(sliderWidth / 70);
        minThumbnailWidth = 55;
        maxThumbnailWidth = 70;
    }

    const marginRight = 10; // Consistent margin

    const availableWidth = sliderWidth - (visibleThumbnails - 1) * marginRight;
    let newThumbnailWidth = Math.floor(availableWidth / visibleThumbnails);
    newThumbnailWidth = Math.max(minThumbnailWidth, Math.min(newThumbnailWidth, maxThumbnailWidth));

    thumbnails.forEach(thumbnail => {
        thumbnail.style.width = `${newThumbnailWidth}px`;
        thumbnail.style.height = `${newThumbnailWidth}px`;
        thumbnail.style.marginRight = `${marginRight}px`;
    });

    // Update CSS custom properties
    document.documentElement.style.setProperty('--thumbnail-width', `${newThumbnailWidth}px`);
    document.documentElement.style.setProperty('--thumbnail-height', `${newThumbnailWidth}px`);
    document.documentElement.style.setProperty('--thumbnail-margin', `${marginRight}px`);

    // Check if navigation is needed after layout adjustment
    checkNavigationNeeded(slider);

    // Update button visibility after layout adjustment
    updateButtonVisibility(slider);
}

function checkNavigationNeeded(slider) {
    const wrapper = slider.closest('.flex-control-nav-wrapper');
    const navContainer = wrapper.querySelector('.thumbnail-nav');
    const thumbnails = slider.querySelectorAll('li');
    const sliderWidth = slider.offsetWidth;
    const totalWidth = Array.from(thumbnails).reduce((sum, thumb) => sum + thumb.offsetWidth + parseInt(getComputedStyle(thumb).marginRight), 0);

    if (totalWidth <= sliderWidth) {
        navContainer.style.display = 'none';
        slider.style.justifyContent = 'center';
    } else {
        navContainer.style.display = 'flex';
        slider.style.justifyContent = 'flex-start';
    }

    // Update button visibility after checking navigation
    updateButtonVisibility(slider);
}

function updateButtonVisibility(slider) {
    const wrapper = slider.closest('.flex-control-nav-wrapper');
    const prevButton = wrapper.querySelector('.thumbnail-nav .prev');
    const nextButton = wrapper.querySelector('.thumbnail-nav .next');

    // Check if scroll is at the start
    if (slider.scrollLeft <= 10) {
        prevButton.style.opacity = '0';
        prevButton.style.pointerEvents = 'none';
    } else {
        prevButton.style.opacity = '1';
        prevButton.style.pointerEvents = 'auto';
    }

    // Check if scroll is at the end
    if (slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 10) {
        nextButton.style.opacity = '0';
        nextButton.style.pointerEvents = 'none';
    } else {
        nextButton.style.opacity = '1';
        nextButton.style.pointerEvents = 'auto';
    }
}

function smoothScroll(element, amount, duration) {
    const start = element.scrollLeft;
    const startTime = performance.now();

    function animateScroll(currentTime) {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < duration) {
            element.scrollLeft = easeInOutCubic(elapsedTime, start, amount, duration);
            requestAnimationFrame(animateScroll);
        } else {
            element.scrollLeft = start + amount;
            snapToEdge(element);
        }
    }

    requestAnimationFrame(animateScroll);
}

function snapToEdge(slider) {
    if (slider.scrollLeft <= 10) {
        slider.scrollLeft = 0;
    } else if (slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 10) {
        slider.scrollLeft = slider.scrollWidth - slider.offsetWidth;
    }
    updateButtonVisibility(slider);
}

function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
}

function throttle(func, limit) {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}





// !!! Uncomment the code below to enable VAT calculator on specific products (If YITH has not fixed the issue) !!!


// function initVATCalculator() {
//     const VAT_RATE = 0.20; // 20% VAT rate for UK
//     let updateTimeout = null;

//     function parsePrice(priceString) {
//         return parseFloat(priceString.replace(/[^0-9.-]+/g, ""));
//     }

//     function formatPrice(price) {
//         return `£${price.toFixed(2)}`;
//     }

//     function calculateExVAT(priceIncVAT) {
//         return priceIncVAT / (1 + VAT_RATE);
//     }

//     function updatePriceElement(element) {
//         if (!element) return;

//         const priceSpan = element.querySelector('.woocommerce-Price-amount bdi');
//         const exVatSpan = element.querySelector('.woocommerce-price-suffix .woocommerce-Price-amount');

//         if (priceSpan && exVatSpan) {
//             const priceIncVAT = parsePrice(priceSpan.textContent);
//             const priceExVAT = calculateExVAT(priceIncVAT);
//             exVatSpan.textContent = formatPrice(priceExVAT);
//         }
//     }

//     function updateAllPrices() {
//         updatePriceElement(document.querySelector('.summary .price'));
//         updatePriceElement(document.getElementById('wapo-total-options-price'));
//         updatePriceElement(document.getElementById('wapo-total-order-price'));
//         document.querySelectorAll('.yith-wapo-option .option-price').forEach(updatePriceElement);
//     }

//     function debouncedUpdate() {
//         clearTimeout(updateTimeout);
//         updateTimeout = setTimeout(updateAllPrices, 100);
//     }

//     const observerConfig = { childList: true, subtree: true, characterData: true, attributes: true };

//     const observer = new MutationObserver((mutations) => {
//         for (const mutation of mutations) {
//             if (mutation.target && (
//                 (mutation.target.classList && mutation.target.classList.contains('woocommerce-Price-amount')) ||
//                 (mutation.target.id === 'wapo-total-price-table') ||
//                 (mutation.target.classList && mutation.target.classList.contains('price')) ||
//                 (mutation.target.classList && mutation.target.classList.contains('option-price'))
//             )) {
//                 debouncedUpdate();
//                 break;
//             }
//         }
//     });

//     observer.observe(document.body, observerConfig);

//     updateAllPrices();

//     window.addEventListener('load', debouncedUpdate);

//     document.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
//         input.addEventListener('change', debouncedUpdate);
//     });
// }

// function launchVATCalculator(productIds = []) {
//     function getProductIdFromBody() {
//         const bodyClasses = document.body.classList;
//         for (const className of bodyClasses) {
//             if (className.startsWith('postid-')) {
//                 return parseInt(className.replace('postid-', ''), 10);
//             }
//         }
//         return null;
//     }

//     const currentProductId = getProductIdFromBody();

//     if (productIds.length === 0 || productIds.includes(currentProductId)) {
//         initVATCalculator();
//     }
// }

// launchVATCalculator([116, 1878]);


// // Usage examples:
// // Launch for specific product IDs:
// // launchVATCalculator([1878, 1234, 5678]);

// // Launch for all products:
// // launchVATCalculator();

document.addEventListener('DOMContentLoaded', function () {
    // Check if we're on a WooCommerce single product page
    if (!document.body.classList.contains('single-product')) return;

    // Find all before-after image containers
    const containers = document.querySelectorAll('.before-after-image');
    if (!containers.length) return;

    containers.forEach((container, index) => {
        const beforeSrc = container.getAttribute('data-image-before');
        const afterSrc = container.getAttribute('data-image-after');

        if (!beforeSrc || !afterSrc) return;

        // Create the slider HTML structure
        const sliderHTML = `
            <div class="ba-slider" id="ba-slider-${index}">
                <div class="ba-image-container">
                    <img class="ba-image ba-image-after" src="${afterSrc}" alt="After">
                    <div class="ba-image-before-wrapper">
                        <img class="ba-image ba-image-before" src="${beforeSrc}" alt="Before">
                    </div>
                    <div class="ba-divider">
                        <div class="ba-divider-line"></div>
                        <div class="ba-divider-handle">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <path
                                d="M0 12 L8 8 L8 16 Z   M16 8 L24 12 L16 16 Z"
                                fill="currentColor"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        `;

        container.innerHTML = sliderHTML;

        // Initialize the slider functionality
        const slider = container.querySelector('.ba-slider');
        const beforeWrapper = slider.querySelector('.ba-image-before-wrapper');
        const divider = slider.querySelector('.ba-divider');
        const imageContainer = slider.querySelector('.ba-image-container');

        let isDragging = false;

        function updateSliderPosition(x) {
            const rect = imageContainer.getBoundingClientRect();
            const offsetX = x - rect.left;
            const percentage = (offsetX / rect.width) * 100;
            const clampedPercentage = Math.max(0, Math.min(100, percentage));

            beforeWrapper.style.width = clampedPercentage + '%';
            divider.style.left = clampedPercentage + '%';
        }

        function startDrag(e) {
            isDragging = true;
            e.preventDefault();
            imageContainer.classList.add('ba-dragging');
        }

        function drag(e) {
            if (!isDragging) return;
            const x = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            updateSliderPosition(x);
        }

        function endDrag() {
            isDragging = false;
            imageContainer.classList.remove('ba-dragging');
        }

        // Mouse events
        divider.addEventListener('mousedown', startDrag);
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', endDrag);

        // Touch events
        divider.addEventListener('touchstart', startDrag);
        document.addEventListener('touchmove', drag);
        document.addEventListener('touchend', endDrag);

        // Click to position
        imageContainer.addEventListener('click', function (e) {
            if (e.target === divider || divider.contains(e.target)) return;
            updateSliderPosition(e.clientX);
        });

        // Ensure images are loaded before showing
        const images = slider.querySelectorAll('.ba-image');
        let loadedCount = 0;

        images.forEach(img => {
            if (img.complete) {
                loadedCount++;
                if (loadedCount === 2) slider.classList.add('ba-loaded');
            } else {
                img.addEventListener('load', () => {
                    loadedCount++;
                    if (loadedCount === 2) slider.classList.add('ba-loaded');
                });
            }
        });
    });
});





document.addEventListener('DOMContentLoaded', function () {
    // Check if we're on a single product page
    if (!document.body.classList.contains('single-product')) {
        return; // Exit if not on single product page
    }

    // Event delegation for the Feefo review badge
    document.addEventListener('click', function (e) {
        // Check if clicked element or its parent is the Feefo badge
        const badge = e.target.closest('.feefo-review-badge-wrapper-product');
        if (!badge) return;

        e.preventDefault();

        // Find the reviews tab - checking multiple possible selectors
        let reviewsTab = null;

        // First try: common review tab classes
        reviewsTab = document.querySelector('.wc-tabs li.reviews, .wc-tabs li.reviews_tab, .wc-tabs li[class*="review"]');

        // Second try: by ID pattern
        if (!reviewsTab) {
            reviewsTab = document.querySelector('.wc-tabs li[id*="review" i]');
        }

        // Third try: by href pattern
        if (!reviewsTab) {
            const tabsWithReviewHref = document.querySelectorAll('.wc-tabs li a[href*="review" i]');
            if (tabsWithReviewHref.length > 0) {
                reviewsTab = tabsWithReviewHref[0].closest('li');
            }
        }

        // Final fallback: find by text content
        if (!reviewsTab) {
            const tabs = document.querySelectorAll('.wc-tabs li');
            reviewsTab = Array.from(tabs).find(tab => {
                const link = tab.querySelector('a');
                return link && link.textContent.trim().toUpperCase().includes('REVIEW');
            });
        }

        // Exit if no reviews tab found
        if (!reviewsTab) {
            console.log('Reviews tab not found');
            return;
        }

        // Get the tab link
        const tabLink = reviewsTab.querySelector('a');
        if (!tabLink) return;

        const tabTarget = tabLink.getAttribute('href');
        const tabContent = tabTarget ? document.querySelector(tabTarget) : null;

        // Verify the tab content exists
        if (!tabContent) {
            console.log('Reviews tab content not found');
            return;
        }

        // Check if tab is already active
        const isActive = reviewsTab.classList.contains('active') ||
            tabLink.getAttribute('aria-selected') === 'true';

        // Function to scroll to the tab
        function scrollToReviews() {
            // Calculate scroll position with offset for fixed headers
            const scrollOffset = 100; // Adjust this if you have a fixed header
            const rect = tabContent.getBoundingClientRect();
            const scrollPosition = window.pageYOffset + rect.top - scrollOffset;

            // Smooth scroll to the tab
            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        }

        if (isActive) {
            // Tab is already open, just scroll
            scrollToReviews();
        } else {
            // Trigger tab click first
            tabLink.click();

            // Small delay to ensure tab is switched before scrolling
            setTimeout(scrollToReviews, 100);
        }
    });
});






// Region price notification under single product price
function getCountryFromCookie() {
    const match = document.cookie.match(/(?:^|;\s*)sky_geo_country=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}

function getRegionMessagesFromJson() {
    const script = document.getElementById('sky-region-variations');
    if (!script) return null;

    try {
        const data = JSON.parse(script.textContent);
        return (data && typeof data === 'object') ? data : null;
    } catch (e) {
        return null;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // Only on single product pages
    if (!document.body.classList.contains('single-product')) return;

    const regionEl = document.querySelector('.region-notification');
    if (!regionEl) return;

    const delayMs = 5000; // delay for second attempt if cookie isn't ready
    const regionMessages = getRegionMessagesFromJson(); // from ACF JSON, if present
    let hasRetried = false;

    function tryShowRegionMessage() {
        const rawCountry = getCountryFromCookie();
        const country = rawCountry ? rawCountry.toUpperCase() : '';

        // If no country yet and we haven't retried, schedule one retry
        if (!country) {
            if (!hasRetried) {
                hasRetried = true;
                setTimeout(tryShowRegionMessage, delayMs);
            }
            return;
        }

        // If UK, we simply leave the reserved line empty (no visible text)
        if (country === 'GB' || country === 'UK') {
            return;
        }

        let html = null;

        if (regionMessages) {
            // Exact match, e.g. "TR"
            if (Object.prototype.hasOwnProperty.call(regionMessages, country)) {
                html = regionMessages[country];
            }
            // Optional fallback row with Country Code = "*" in ACF
            else if (Object.prototype.hasOwnProperty.call(regionMessages, '*')) {
                html = regionMessages['*'];
            }
        }

        // If nothing found in ACF, return without showing anything
        if (!html) {
            return;
        }

        if (html) {
            regionEl.innerHTML = html;
            regionEl.classList.add('is-visible');
        }
    }

    // First attempt immediately – fast for users who already have the cookie
    tryShowRegionMessage();
});

